// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__35KQm","left":"StickyBox_left__2xwTz","right":"StickyBox_right__2hGnt"};